import {useStaticQuery, graphql} from 'gatsby'

export const getAllPosCourses = graphql`
  query GetAllPosCourses {
    allMdx(
      filter: {frontmatter: {templateKey: {eq: "pos-course-page"}}}
      sort: {order: DESC, fields: frontmatter___publish}
    ) {
      nodes {
        slug
        frontmatter {
          title
          titleCard
          subtitle
          templateKey
          cover
          investiment {
            investmentValue
            investmentOldValue
          }
          professors
        }
      }
    }
  }
`

const usePosCoursesQuery = () => {
  const {allMdx} = useStaticQuery(getAllPosCourses)
  const courses = allMdx.nodes.map(item => ({
    slug: item.slug,
    ...item.frontmatter,
  }))

  return courses
}

export {usePosCoursesQuery}
